module.exports = __webpack_public_path__ + "static/media/android_badge.19986690.png";